import { AnalyticEventCategory, AnalyticEventType } from '../../../../../../../shared/entity_datas/EntityDatas.ts';
import { StoreItemCategory, StorePresalePackType } from '../../../../../../../shared/entity_datas/StoreEnums.ts';
import { ColonistCoinProduct } from '../../../../../../../shared/store/ColonistCoinProduct.ts';
import { ColonistMembershipProduct } from '../../../../../../../shared/store/ColonistMembershipProduct.ts';
import { StoreItemController } from '../../../../../../../shared/store/StoreItemController.ts';
import { CA } from '../../../../../../shared/scripts/analytics/Analytics.ts';
import { areYouSureToBuy, areYouSureToBuyFounderDiscount, doActionIfCanGiftMembership, doActionIfLoggedIn } from '../../../../../../shared/scripts/store/StoreUtils.ts';
import { UIStoreAjaxEndPoints } from '../../../../../../shared/scripts/store/UIStoreAjaxEndPoints.ts';
import { UIStoreBodyController } from '../../../../../../shared/scripts/store/UIStoreBodyController.ts';
import { UIMStoreMembershipProductView } from './UIMStoreMembershipProductView.ts';
import { UIStoreMembershipTabsController } from '../../../../../../shared/scripts/store/UIStoreMembershipTabsController.ts';
import { applyOwnedMembershipToViews } from '../../../../../../shared/scripts/store/applyOwnedMembershipToViews.ts';
import { UIMCoinProductView } from './UIMCoinProductView.ts';
import * as Item from '../../../../../../../shared/store/StoreItemList.ts';
import { UIMStoreItemView } from './UIMStoreItemView.ts';
import { notificationController } from '../../../../../../shared/scripts/EntryShared.ts';
import { UITopNotificationType } from '../../../../../../shared/scripts/notifications/UINotificationController.ts';
import { ColonistMembershipPerkType } from '@colonist/lobby-types';
import { UIGiftedMembershipProductView } from '../../../../../../shared/scripts/store/UIGiftedMembershipProductView.ts';
import { ClientUserState } from '../../../../../../shared/scripts/ClientUserState.ts';
import { StorageWrapper } from '../../../../../../shared/scripts/StorageWrapper.ts';
import { UIMStoreGiftOverlayController } from '../../../store/gift/UIMStoreGiftOverlayController.ts';
import { UIMDeviceHandler } from '../../../UIMDeviceHandler.ts';
import { setElementOnClick } from '../../../../../../shared/scripts/ui_utils/DomUtils.ts';
import { showItemInfoDialog } from '../../../../../../shared/scripts/ui_popup/showItemInfoDialog.ts';
import { ReferralProgramUtils } from '../../../../../../shared/scripts/referral/ReferralProgramUtils.ts';
import { UIStoreReferralController } from '../../../../../../shared/scripts/store/UIStoreReferralController.ts';
import { clientI18n } from '../../../../../../shared/scripts/ClientI18n.ts';
import { UIUtilsEjsVariables } from '../../../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { UIMDiscordActivityController } from '../../../../discord/UIMDiscordActivityController.ts';
export class UIMStoreBodyController extends UIStoreBodyController {
    createMembershipItems() {
        this.membershipsDiv.replaceChildren();
        this.membershipItems.length = 0;
        const membershipProducts = ColonistMembershipProduct.getAllMembershipProducts();
        for (const product of membershipProducts){
            const localizedSubscription = this.localizedStoreSubscriptionData.find((data)=>data.subscriptionId === product.mobileIAPSKUId);
            const monthlyProduct = ColonistMembershipProduct.getMonthlyProductOfAnnualMembership(product.type);
            const localizedMonthlySubscription = monthlyProduct ? this.localizedStoreSubscriptionData.find((data)=>data.subscriptionId === monthlyProduct.mobileIAPSKUId) : undefined;
            const membership = new UIMStoreMembershipProductView(this.membershipsDiv, this.storeState, product, this.giftOverlayController, localizedSubscription, localizedMonthlySubscription);
            this.membershipItems.push(membership);
        }
        this.membershipTabsController = new UIStoreMembershipTabsController(this.storeState);
    }
    updateAllCategoryItems() {
        this.items.length = 0;
        this.updateCategoryItems(StoreItemCategory.Expansion, this.expansionsDiv);
        this.updateCategoryItems(StoreItemCategory.Map, this.mapsDiv);
        this.updateCategoryItems(StoreItemCategory.Color, this.colorsDiv);
        this.updateCategoryItems(StoreItemCategory.Icon, this.avatarsDiv);
    }
    updateCategoryItems(category, container) {
        container.replaceChildren();
        const itemDetails = StoreItemController.getItemsInCategory(category);
        for (const itemDetail of itemDetails){
            const item = new UIMStoreItemView(container, itemDetail, ()=>doActionIfCanGiftMembership(()=>this.giftOverlayController.show()), ()=>{
                const eventData = {
                    type: AnalyticEventType.StoreClickedPurchaseItem,
                    category: AnalyticEventCategory.Store,
                    floatValue: item.itemDetail.type
                };
                void CA.sendAnalyticEvent(eventData);
                const isBlackColor = itemDetail.name.key == new Item.SIColorBlack().name.key;
                if (!isBlackColor) {
                    var _ClientUserState_userState;
                    var _ClientUserState_userState_forceSubscription;
                    const forceSubscription = (_ClientUserState_userState_forceSubscription = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.forceSubscription) !== null && _ClientUserState_userState_forceSubscription !== void 0 ? _ClientUserState_userState_forceSubscription : true;
                    const subscriptionCategory = itemDetail.category == StoreItemCategory.Expansion || itemDetail.category == StoreItemCategory.Map || itemDetail.category == StoreItemCategory.Color;
                    if (forceSubscription && subscriptionCategory) {
                        this.sidebarController.openMembership();
                        return;
                    }
                }
                doActionIfLoggedIn(()=>{
                    areYouSureToBuy(itemDetail, ()=>{
                        void UIStoreAjaxEndPoints.purchaseItem(itemDetail, undefined, (text)=>notificationController.show(text, UITopNotificationType.Error));
                    }, ()=>notificationController.show({
                            key: 'strings:storePage.message.notEnoughCoins'
                        }, UITopNotificationType.Error, {
                            key: 'strings:storePage.coins.buyCoins'
                        }, ()=>this.sidebarController.openCoins()));
                });
            });
            this.items.push(item);
        }
    }
    updateOwnedItems(ownedItems) {
        this.updateAllCategoryItems();
        void this.updateReferralProgram();
        for (const ownedItem of ownedItems){
            for (const itemView of this.items){
                if (itemView.itemDetail.name.key == ownedItem.name.key) {
                    itemView.markAsOwned();
                    break;
                }
            }
        }
    }
    updateSubscribedItems(ownedMembership, paymentMethod) {
        if (ownedMembership == undefined) return;
        for (const perk of ownedMembership.perks){
            if (perk.type == ColonistMembershipPerkType.AllColors) {
                this.markItemsAsSubscribed(StoreItemCategory.Color);
            }
            if (perk.type == ColonistMembershipPerkType.AllMaps) {
                this.markItemsAsSubscribed(StoreItemCategory.Map);
            }
            if (perk.type == ColonistMembershipPerkType.AllExpansions) {
                this.markItemsAsSubscribed(StoreItemCategory.Expansion);
            }
        }
    }
    markItemsAsSubscribed(category) {
        for (const itemView of this.items){
            if (itemView.itemDetail.category != category) continue;
            itemView.markAsSubscribed();
        }
    }
    updateOwnedMembership(ownedMembership, paymentMethod) {
        this.createMembershipItems();
        applyOwnedMembershipToViews(this.membershipItems, ownedMembership, paymentMethod);
    }
    updatePriceForFounderPack(ownedItems) {
        const hasFounderPack = UIMStoreBodyController.hasFounderPack(ownedItems);
        if (!hasFounderPack) return;
        for (const itemView of this.items){
            if (itemView.isMarkedOwned) continue;
            if (itemView.itemDetail.category != StoreItemCategory.Expansion && itemView.itemDetail.category != StoreItemCategory.Map) continue;
            itemView.makePrice0();
            itemView.updateAction(()=>{
                areYouSureToBuyFounderDiscount(itemView.itemDetail, ()=>{
                    void UIStoreAjaxEndPoints.purchaseItem(itemView.itemDetail, (text)=>notificationController.show(text, UITopNotificationType.Success), (text)=>notificationController.show(text, UITopNotificationType.Error));
                });
            });
        }
    }
    static hasFounderPack(ownedItems) {
        for (const item of ownedItems){
            if (item.category != StoreItemCategory.PresalePack) continue;
            if (item.type != StorePresalePackType.FounderPack) continue;
            return true;
        }
        return false;
    }
    updateGiftedMemberships(memberships) {
        var _document_getElementById;
        const grid = document.getElementById('store_page_gifted_memberships_div');
        if (grid == undefined) return;
        grid.replaceChildren();
        (_document_getElementById = document.getElementById('gifted_memberships')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.toggle('hidden', memberships.length == 0);
        for (const membership of memberships){
            const localizedGiftMembership = this.localizedStoreProductData.find((data)=>data.productId == membership.id);
            new UIGiftedMembershipProductView(grid, this.storeState, membership, async (id)=>{
                await UIStoreAjaxEndPoints.activateGiftedMembership(id);
            }, localizedGiftMembership);
        }
    }
    // eslint-disable-next-line class-methods-use-this
    async onInviteFriendsButtonClick(referralReward, userReferralCount) {
        if (UIUtilsEjsVariables.isUserOnDiscord) {
            UIMDiscordActivityController.getInstance().shareStoreReferral(referralReward);
            return;
        }
        const link = await ReferralProgramUtils.getReferralLinkForSharing();
        UIMDeviceHandler.sendShareLink(link, clientI18n.t('strings:storePage.sections.referral.mobileCTA'));
        const eventData = {
            type: AnalyticEventType.ReferralAnalytics,
            category: AnalyticEventCategory.MobileStoreReferralProgramReferFriends,
            floatValue: referralReward.analyticsPopupTriggered
        };
        void CA.sendAnalyticEvent(eventData);
    }
    // eslint-disable-next-line class-methods-use-this
    setupReferralRewardClickHandler(contentDiv, description, image, referralReward) {
        setElementOnClick(contentDiv, ()=>{
            showItemInfoDialog(referralReward.name, referralReward.image, UIStoreReferralController.loadReferralItemDescription(referralReward));
        });
    }
    onStoreViewVisible() {
        void this.updateReferralProgram();
    }
    constructor(storeState, sidebarController){
        super(), this.items = [], this.membershipItems = [];
        this.membershipsDiv = document.getElementById('store_page_memberships_div');
        this.expansionsDiv = document.getElementById('store_page_expansions_div');
        this.mapsDiv = document.getElementById('store_page_maps_div');
        this.colorsDiv = document.getElementById('store_page_colors_div');
        this.avatarsDiv = document.getElementById('store_page_avatars_div');
        this.coinsDiv = document.getElementById('store_page_coins_div');
        this.localizedStoreSubscriptionData = UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() ? StorageWrapper.getLocalizedStoreSubscriptionData() : [];
        this.localizedStoreProductData = UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() ? StorageWrapper.getLocalizedStoreProductData() : [];
        this.storeState = storeState;
        this.sidebarController = sidebarController;
        this.giftOverlayController = new UIMStoreGiftOverlayController(document.body, this.storeState, this.localizedStoreProductData);
        this.createMembershipItems();
        this.updateAllCategoryItems();
        const coinProducts = ColonistCoinProduct.getAllCoinProducts();
        for (const product of coinProducts){
            const localizedProductData = this.localizedStoreProductData.find((data)=>data.productId == product.mobileIAPSKUId);
            new UIMCoinProductView(this.coinsDiv, product, localizedProductData);
        }
    }
}
